import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { UserManagementService } from "../user-management.service";
import { AlertifyService } from "src/app/UtilityService/alertify.service";

@Component({
    selector: "app-Signup-confirm",
    templateUrl: "./signup-confirm.component.html",
    styleUrls: ["./signup-confirm.component.css"],
    standalone: false
})
export class SignupconfirmComponent implements OnInit, OnDestroy {
  @Input() username?: any;
  public signupFormConfirm!: FormGroup;
  timeLeft: number = 60; // 1 minute timer
  private interval: any;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private alertify: AlertifyService,
    private userService: UserManagementService
  ) {
    this.startTimer();
  }

  ngOnInit(): void {
    this.signupFormConfirm = this.fb.group({
      otp: [
        "",
        [
          Validators.required,
          Validators.pattern(/^\d{6}$/),
        ],
      ],
    });
  }

  submit(): void {
    if (this.signupFormConfirm.valid) {
      const code = this.signupFormConfirm.controls.otp.value;
      const request = {
        username: this.username,
        confirmation_code: code,
      };
      this.userService.confirmsignUp(request).then((response: any) => {
        if (response?.success) {
          this.activeModal.dismiss();
          this.showAlert(
            response?.message ||
              "Email verified successfully. Admin approval is pending."
          );
        } else {
          this.showAlert(
            response?.message || "Invalid confirmation code. Please try again."
          );
        }
      }).catch((error: any) => {
        this.showAlert(
          error?.error?.message ||
            error?.message ||
            "Verification failed. Please try again."
        );
      });
    } else {
      this.signupFormConfirm.markAllAsTouched();
      this.alertify.error("Please enter a valid 6 digit OTP.");
    }
  }

  public dissmissModal() {
    this.activeModal.dismiss();
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  startTimer() {
    this.timeLeft = 60; // Reset the timer
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        clearInterval(this.interval); // Clear the timer
      }
    }, 1000);
  }

  resendOtp() {
    this.startTimer(); // Restart the timer on resend
  }
  showAlert(msg) {
    Swal.fire({
      title: msg,
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
    });
  }
}
